import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DocumnentLibraryComponent } from "./components/documnent-library/documnent-library.component";


const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'document-library'
  },
  {
    path: 'document-library',
    component: DocumnentLibraryComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule],
})
export class DocumentLibraryRoutingModule { }
